import EntryDetail from './EntryDetail';
import EntryList from './EntryList';

const contentful = {
  EntryDetail,
  EntryList,
};

export default contentful;